import { render, staticRenderFns } from "./DonateThanks.vue?vue&type=template&id=7e250f62&scoped=true"
import script from "./DonateThanks.vue?vue&type=script&lang=js"
export * from "./DonateThanks.vue?vue&type=script&lang=js"
import style0 from "./DonateThanks.vue?vue&type=style&index=0&id=7e250f62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e250f62",
  null
  
)

export default component.exports